import { ChangeReasonDialog, ChangeReasonResult } from "./ChangeReasonDialog";
import { ChangeEventReason, REASON_LABELS } from "@/lib/change-events";

export interface CancelConfirmPayload {
  /** Stable enum reason, persisted into `change_events.reason`. */
  reason: ChangeEventReason;
  /** Human label, persisted into `orders.cancellation_reason`. */
  reasonLabel: string;
  /** Required when reason is "other"; also written to `orders.cancellation_notes`. */
  otherText: string | null;
}

interface CancelOrderDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  orderId: string;
  onConfirm: (payload: CancelConfirmPayload) => void;
  isPending?: boolean;
}

/**
 * Cancellation prompt. Backed by the shared `ChangeReasonDialog` so the
 * dispatcher-supplied reason is captured in the canonical `change_events`
 * matrix (see src/lib/change-events.ts), in addition to the legacy
 * `orders.cancellation_reason` / `cancellation_notes` columns.
 */
export function CancelOrderDialog({
  open,
  onOpenChange,
  orderId,
  onConfirm,
  isPending,
}: CancelOrderDialogProps) {
  const handleConfirm = (results: ChangeReasonResult[]) => {
    const r = results[0];
    if (!r) return;
    onConfirm({
      reason: r.reason,
      reasonLabel: REASON_LABELS[r.reason],
      otherText: r.otherText,
    });
  };

  return (
    <ChangeReasonDialog
      open={open}
      onOpenChange={onOpenChange}
      events={[{ key: "cancel", eventType: "trip_cancelled" }]}
      orderUniqueId={orderId}
      confirmLabel={isPending ? "Canceling…" : undefined}
      isPending={isPending}
      alwaysShowNotes
      onConfirm={handleConfirm}
    />
  );
}
